export default {
  set(functionName, interval) {
    const intervalId = window.setInterval(functionName, interval);

    return intervalId;
  },

  clear(intervalId) {
    window.clearInterval(intervalId);
  },
};
